import moment from "moment";
import React, { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import secureStorage from "../../../../../services/secureStorage";
import {
  ArrowDown,
  NewComment,
  SendMessage,
  Upload,
} from "../../../../../utility/constants/assetsManager";
import {
  SS_EMAIL,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_ROLE,
  SS_USER_HASH_ID,
} from "../../../../../utility/constants/secureStorageManager";
import {
  ADMIN,
  ADMIN_USER,
  RNC,
  STATUS_CODE_200,
  STATUS_OK,
} from "../../../../../utility/constants/valueConstants";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { CustomLoader } from "../../../../components/main_comps/custom_loader";

const CommentContainer = ({
  onClickOpenChat,
  currentChat,
  index,
  title = "Name",
  data,
}) => {
  const [clientData, setClientData] = useState({});
  const [newMessage, setNewMessage] = useState("");
  const [message, setMessage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newMessageLoading, setNewMessageLoading] = useState(false);
  const userId = secureStorage.getItem(SS_USER_HASH_ID);
  const fn = secureStorage.getItem(SS_FIRST_NAME);
  const ln = secureStorage.getItem(SS_LAST_NAME);
  const emailId = secureStorage.getItem(SS_EMAIL);
  const role = secureStorage.getItem(SS_ROLE);

  const addCommentsWithRoomId = () => {
    setNewMessageLoading(true);
    let senderDetails = {
      emailId,
      name: fn + " " + ln,
    };

    let user = [
      { email: emailId, name: fn + "" + ln },
      { email: data?.createdBy?.email, name: data?.createdBy?.userName },
    ];
    ApiRequestPost.addComments({
      roomId: title.replace(/\s+/, "").toUpperCase() + clientData?.userId,
      content: newMessage,
      senderId: userId,
      senderDetails,
      user,
      roomName: title,
    })
      .then((res) => {
        if (res.status === STATUS_OK) {
          setNewMessage("");
          setMessage([
            {
              content: newMessage,
              senderId: userId,
              senderDetails,
              roomId: "",
              createdAt: Date.now(),
            },
            ...message,
          ]);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setNewMessageLoading(false);
      });
  };

  const fetchCommentsByRoomId = () => {
    setLoading(true);
    ApiRequestGet.fetchCommentsByRoomId({
      roomid: title.replace(/\s+/, "").toUpperCase() + data?.userId,
    })
      .then((res) => {
        if (res.status === STATUS_OK) {
          setMessage(res?.data);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (currentChat === index) {
      fetchCommentsByRoomId();
      setClientData(data);
    }
  }, [currentChat]);
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
          backgroundColor: currentChat === index ? "#FAFAFA" : "#FFFFFF",
          marginTop: "10px",
        }}
      >
        <div
          style={{
            padding: "10px 30px",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            cursor: "pointer",
            marginTop: "10px",
          }}
          onClick={() => onClickOpenChat()}
        >
          <p
            style={{
              color: "#2D3560",
              fontSize: "15px",
            }}
          >
            {title}
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            {/* <NewComment /> */}
            <ArrowDown />
          </div>
        </div>

        {currentChat === index && (
          <div>
            <div
              style={{
                maxHeight: "200px",
                padding: "5px 30px",
                overflow: "auto",
                display: "flex",
                flexDirection: "column-reverse",
              }}
            >
              {message.length > 0 ? (
                message.map((content, i) => {
                  return (
                    <div style={{ marginBottom: "20px" }} key={i}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <div
                            style={{
                              backgroundColor:
                                content.senderId === userId
                                  ? "#FC9F14"
                                  : "#38369C",
                              width: "25px",
                              height: "25px",
                              borderRadius: "12px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "white",
                                margin: 0,
                              }}
                            >
                              {content?.senderDetails?.name?.slice(0, 1)}
                            </p>
                          </div>

                          <p
                            style={{
                              color: "#2D3560",
                              fontSize: "16px",
                              fontWeight: "500",
                            }}
                          >
                            {content?.senderDetails?.name}
                          </p>
                          <p
                            style={{
                              color: "#A8A7B4",
                              fontSize: "12px",
                            }}
                          >
                            {moment(content?.createdAt).format(
                              "MMM DD hh:mm A"
                            )}
                          </p>
                        </div>

                        <div
                          style={{
                            gap: 2,
                            display: "none",
                            flexDirection: "column",
                            cursor: "pointer",
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "#050920",
                              width: "3px",
                              height: "3px",
                              borderRadius: "3px",
                            }}
                          />
                          <div
                            style={{
                              backgroundColor: "#050920",
                              width: "3px",
                              height: "3px",
                              borderRadius: "3px",
                            }}
                          />
                          <div
                            style={{
                              backgroundColor: "#050920",
                              width: "3px",
                              height: "3px",
                              borderRadius: "3px",
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ padding: "0px 10px" }}>
                        <p
                          style={{
                            color: "#69687D",
                            fontSize: "14px",
                            marginLeft: "25px",
                            marginTop: "5px",
                          }}
                        >
                          {content?.content}
                        </p>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {loading ? (
                    <CustomLoader />
                  ) : (
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        margin: "10px 0px",
                      }}
                    >
                      {role === RNC
                        ? `Raise query related to the ${title} section`
                        : "No Comments found"}
                    </p>
                  )}
                </div>
              )}
            </div>

            {(message.length > 0 || role === RNC) &&
              role !== ADMIN_USER &&
              role !== ADMIN && (
                <div
                  style={{
                    display: "flex",
                    padding: "10px 30px",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#FC9F14",
                      width: "25px",
                      height: "25px",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "white",
                        margin: 0,
                      }}
                    >
                      {fn?.slice(0, 1)}
                    </p>
                  </div>

                  <div
                    style={{
                      backgroundColor: "white",
                      height: "32px",
                      width: "90%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderRadius: "5px",
                      paddingRight: "10px",
                    }}
                  >
                    <CustomInput
                      type={"input"}
                      value={newMessage}
                      placeholder={
                        message.length > 0 ? "Reply" : "Start converstion"
                      }
                      onChange={(data) => {
                        setNewMessage(data);
                      }}
                      inputStyles={{
                        width: "90%",
                        border: "0px solid #E8E8E8",
                        boxShadow: "none",
                        backgroundColor: "white",
                        height: "32px",
                      }}
                      validator="businessName"
                      onPressEnter={() => {
                        if (newMessage) {
                          addCommentsWithRoomId();
                        }
                      }}
                      // rightIcon={
                      //   <img
                      //     src={require("../../../assets/png/animated.gif")}
                      //     width={30}
                      //     height={30}
                      //     alt="Show Verified Email"
                      //     style={{}}
                      //   />
                      // }
                    />

                    {newMessageLoading ? (
                      <CustomLoader />
                    ) : newMessage ? (
                      <SendMessage
                        style={{ cursor: "pointer", width: 17, height: 17 }}
                        onClick={() => addCommentsWithRoomId()}
                      />
                    ) : (
                      <Upload style={{ cursor: "pointer" }} />
                    )}
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

const CommentModalBody = ({ data, tabs }) => {
  const [currentChat, setCurrentChat] = useState(null);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "10px 0px",
        overflow: "auto",
        height: "100%",
      }}
    >
      <p
        style={{
          color: "#2D3560",
          borderBottom: "1px solid #D9D9D9",
          width: "100%",
          textAlign: "center",
          paddingBottom: "10px",
          fontSize: "15px",
        }}
      >
        Comments
      </p>

      {tabs.map((tab, index) => {
        return (
          <CommentContainer
            onClickOpenChat={() => {
              if (currentChat === index) {
                setCurrentChat(null);
              } else setCurrentChat(index);
            }}
            currentChat={currentChat}
            index={index}
            title={tab}
            data={data}
          />
        );
      })}
    </div>
  );
};

export default CommentModalBody;
